import styled from 'styled-components'

export const FiltersContainer = styled.div`
  margin: 20px 0;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  background: #f7f7f7;
  border-radius: 4px;
  padding: 16px;
`
